'use strict';

module.exports = match;

function match(query, node) {
  return query.tagName === '*' || query.tagName === node.tagName;
}
